module.exports = __webpack_public_path__ + "static/Sample-5-ea051ec955e795e11d669d8a5813ab5e.png";